module.exports = __webpack_public_path__ + "img/coupon-item-choose-ico.7bda2c53.png";